import {
	FormSubmitResponse,
	IFormSubmitResponse
} from "./Models/FormSubmitResponse";
// tslint:disable-next-line: no-unnecessary-class
export class CommunityCareService {
	public static async sendForm(
		endpoint: string,
		payload: {},
		formDatasourceId: string,
		emailToSubmit: string
	): Promise<IFormSubmitResponse | undefined> {
		try {
			const promise = $.ajax({
				contentType: "application/json",
				data: JSON.stringify({formResults: payload, emailToSubmit: emailToSubmit, formDatasourceId: formDatasourceId}),
				type: "POST",
				url: endpoint
			});
			const result = await Promise.resolve(promise);

			return new FormSubmitResponse(result);
		} catch (err) {
			console.warn(err);
		}
	}
}
